var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "XMLID_801_",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_802_",
    d: "M12.794,99.73H5.512a.585.585,0,0,0-.585.585v23.394a.585.585,0,0,0,.585.585h7.282a.585.585,0,0,0,.585-.585V100.315A.585.585,0,0,0,12.794,99.73Z",
    transform: "translate(-4.35 -88.294)",
    fill: "#286c4d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_803_",
    d: "M4.805.341a4.8,4.8,0,1,0,4.8,4.8A4.808,4.808,0,0,0,4.805.341Z",
    transform: "translate(0 -0.341)",
    fill: "#286c4d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_804_",
    d: "M120.718,94.761a8.553,8.553,0,0,0-6.4,2.686V95.927a.585.585,0,0,0-.585-.585h-6.974a.585.585,0,0,0-.585.585v23.394a.585.585,0,0,0,.585.585h7.266a.585.585,0,0,0,.585-.585V107.747c0-3.9,1.059-5.42,3.778-5.42,2.961,0,3.2,2.436,3.2,5.62v11.374a.585.585,0,0,0,.585.585h7.269a.585.585,0,0,0,.585-.585V106.489C130.025,100.69,128.919,94.761,120.718,94.761Z",
    transform: "translate(-94.025 -83.906)",
    fill: "#286c4d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.a322f829eeb48d316996675deefaab37.svg";
export { ForwardRef as ReactComponent };